<template>
  <RevTag :label="tagLabel[state]" size="small" :variant="tagVariant[state]" />
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTag, type Variants } from '@ds/components/Tag'

import type { PolicyState } from '../../type'

import translations from './PolicyStateTag.translations'

defineProps<{
  state: PolicyState
}>()

const i18n = useI18n()

const tagLabel: Record<PolicyState, string> = {
  ACTIVE: i18n(translations.active),
  NOT_STARTED: i18n(translations.awaitingActivation),
  EXPIRED: i18n(translations.expired),
  CANCELLED: i18n(translations.cancelled),
  ON_HOLD: i18n(translations.onHold),
}

const tagVariant: Record<PolicyState, Variants> = {
  ACTIVE: 'success',
  NOT_STARTED: 'info',
  EXPIRED: 'secondary',
  CANCELLED: 'secondary',
  ON_HOLD: 'danger',
}
</script>
